import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    labelAllShares: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the all shares item, including count when available */
            labelAllShares: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AllSharesNavItem.labelAllShares?c=3mswee8vtsvs7", defaultMessage: "All Share Links" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
